import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ToastrService} from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {Router} from '@angular/router';
import {CasinoBetsService} from "../../../services/casino/casino-bets.service";

@Component({
    selector: 'app-casino-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.css']
})
export class CasinoDPoker20PopupComponent implements OnInit {
    passwordForm: any;
    errorMsg: any;
    submitted = false;
    details: any = {};
    player1: any = [];
    player2: any = [];
    tables: any = [];
    winner: any = '';
    other_a:any = '';
    other_b:any = '';
    cards: any = '';
    casino_bets: any = [];
    filter_bets: any = [];
    totalbets: number = 0;
    totalAmount: number = 0;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private casinoBetsService: CasinoBetsService, private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) {

    }


    ngOnInit(): void {
        this.dialogRef.updateSize('100%',);
        if(!this.data.acc_state){
            this.getTeenPattiDetails();
            }else{
              this.getCasinoResultonMarketId();
            }
        this.getCasinoBetsByMarketID();
    }

    getCasinoResultonMarketId(){
        this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
          if(res.length>0){
          const renamedObject = {
            ...res[0],          // Copy all existing properties
            desc: res[0].description, // Rename description to desc
            cards: res[0].result // Rename result to cards
          };
          console.log("renamedObject",renamedObject);
          this.getResults(renamedObject)
        }
        })
      }
    

    getTeenPattiDetails() {
        this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
            if (res.success) {
                this.details = res.data;
                console.log('xxx', this.details);
                this.getResults(this.details[0]);
            }
        });
    }

    private getResults(data: any) {
        const [player1, player2, tables] = this.divideIntoArrays(data.cards);
        this.player1 = player1;
        this.player2 = player2;
        this.tables = tables;
        this.winner = data.win;
        console.log('winner',this.winner);
        this.cards = this.getFirstCharacters(data.cards);
        let desc = data.desc;
        let main_arr = desc.split('##');
        let result = main_arr.map((item:any) => item.split(',')[0]);
        if(result[1].includes('High')){
        this.other_a = "-";
        }
        else{
            
            if(result[1].toLowerCase()=="pair".trim()){
                result[1]="One Pair"    
            }
                this.other_a = result[1]
            
        }
        if(result[2].includes('High')){
        this.other_b = "-";
        }
        else{
            if(result[2].toLowerCase()=="pair".trim()){
                result[2]="One Pair"    
            }
            this.other_b = result[2]
        }
    }

    private divideIntoArrays(playerString: string) {
        // Split the string by comma
        const players = playerString.split(",");

        // Initialize empty arrays
        const player1 = [];
        const player2 = [];
        const tables = [];

        // Loop through players, assigning first two to player1, second two to player2, and remaining to table
        for (let i = 0; i < players.length; i++) {
            if (i < 2) {
                player1.push(players[i]);
            } else if (i < 4) {
                player2.push(players[i]);
            } else {
                tables.push(players[i]);
            }
        }

        // Return an object containing the arrays
        return [player1, player2, tables];
    }

    private getFirstCharacters(inputString: string) {
        const gameArray = inputString.split(',');
        const result = gameArray.map(game => game.charAt(0));
        return result.join(' ');
    }

    getCasinoBetsByMarketID() {
        this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
            console.log('filter_bets data', res);
            this.casino_bets = res;
            this.filter_bets = this.casino_bets;
            this.totalbets = this.casino_bets.length;
            this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
        });
    }

    filterBetsByType(event: any) {
        const filterType = (event.target as HTMLInputElement).value;
        console.log('filterType', filterType);
        if (filterType === 'all') {
            this.filter_bets = this.casino_bets;
        } else if (filterType === 'deleted') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
        } else if (filterType === 'Back') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
        }
        if (filterType === 'Lay') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
        }
        this.totalbets = this.filter_bets.length;
        this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    dismiss() {
        this.dialogRef.close();
    }

}
